module.exports = __webpack_public_path__ + "media/images/registration-04a91ca4b783bbd85f9979e02e6745cf.gif";